import { getItem } from "./cooke-data";

export default function getSessionToken() {
  return getItem("session_token");
}
